import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SERVER_ENDPOINT } from '../shared/websocket.token';

interface MvLoginRequest {
	username: string;
	password: string;
}

interface MvLoginResponse {
	token: string;
}

export const MV_AUTH_TOKEN_STORAGE_KEY = 'mv_auth_token';

@Injectable({
	providedIn: 'root',
})
export class VbLxpAuthService {
	constructor(
		private readonly http: HttpClient,
		@Inject(SERVER_ENDPOINT) private readonly serverEndpoint: string,
	) { }

	login(loginPath: string, username: string, password: string): Observable<MvLoginResponse> {
		const payload: MvLoginRequest = { username, password };
		const normalizedPath = loginPath.replace(/^\//, '');
		return this.http.post<MvLoginResponse>(`${this.serverEndpoint}${normalizedPath}`, payload);
	}

	getToken(storageKey: string = MV_AUTH_TOKEN_STORAGE_KEY): string | null {
		return localStorage.getItem(storageKey);
	}

	saveToken(token: string, storageKey: string = MV_AUTH_TOKEN_STORAGE_KEY): void {
		localStorage.setItem(storageKey, token);
	}

	clearToken(storageKey: string = MV_AUTH_TOKEN_STORAGE_KEY): void {
		localStorage.removeItem(storageKey);
	}
}
